import React from 'react';

const IosIcon = () => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74933 4.81468C6.16533 4.81468 5.26133 4.15068 4.30933 4.17468C3.05333 4.19068 1.90133 4.90268 1.25333 6.03068C-0.0506715 8.29468 0.917329 11.6387 2.18933 13.4787C2.81333 14.3747 3.54933 15.3827 4.52533 15.3507C5.46133 15.3107 5.81333 14.7427 6.94933 14.7427C8.07733 14.7427 8.39733 15.3507 9.38933 15.3267C10.3973 15.3107 11.0373 14.4147 11.6533 13.5107C12.3653 12.4707 12.6613 11.4627 12.6773 11.4067C12.6533 11.3987 10.7173 10.6547 10.6933 8.41468C10.6773 6.54268 12.2213 5.64668 12.2933 5.60668C11.4133 4.31868 10.0613 4.17468 9.58933 4.14268C8.35733 4.04668 7.32533 4.81468 6.74933 4.81468ZM8.82933 2.92668C9.34933 2.30268 9.69333 1.43068 9.59733 0.566681C8.85333 0.598681 7.95733 1.06268 7.42133 1.68668C6.94133 2.23868 6.52533 3.12668 6.63733 3.97468C7.46133 4.03868 8.30933 3.55068 8.82933 2.92668Z"
        fill="var(--primaryText)"
      />
    </svg>
  );
};

export default IosIcon;
